import type { IResolvedUrl } from '@fluidframework/driver-definitions';
import type { PermissionsInfo, ShareService } from '@fluidx/office-fluid-types';

/**
 * A service to handle permissions. Currently suppressed to let OWA handle permissions directly.
 */
export class AppShareService implements ShareService {
    public get ShareServicePromise() {
        return Promise.resolve(this);
    }

    /**
     * @param resolvedUrl: Container resolved url
     * @param userPrincipalName The unique id that identifies the user
     * @returns True, since OWA grants permission on send so we do not need to worry about if the recipient currently has access.
     */
    public async checkUserAccess(_props: {
        resolvedUrl?: IResolvedUrl;
        userPrincipalName: string;
    }): Promise<boolean> {
        return true;
    }

    /**
     * @param resolvedUrl: Container resolved url
     * @param userPrincipalNames The unique ids identifying the recipients to grant permissions to
     * @returns True. Not needed, as we will never grant permissions with this service.
     */
    public async grantPermissions(_props: {
        resolvedUrl?: IResolvedUrl;
        userPrincipalNames: string[];
    }): Promise<boolean> {
        return true;
    }

    /**
     * @param resolvedUrl: Container resolved url
     * @param componentPath The relative path to component within container.
     * @returns True. Not needed as we will never share a link through this service.
     */
    public async shareLink(_props: {
        resolvedUrl?: IResolvedUrl;
        componentPath?: string;
    }): Promise<boolean> {
        return true;
    }

    /**
     * Get information about who has permissions to this file
     * @param resolvedUrl: Container resolved url
     * @returns a promise with list of users who have access or empty list
     */
    public async getPermissions(_props: { resolvedUrl?: IResolvedUrl }): Promise<PermissionsInfo> {
        return {
            links: [],
            personas: [],
        };
    }
}
